/* eslint-disable @typescript-eslint/no-var-requires */
const hiayConfig = require('hiya-common/config.js')
const package = require('./package.json')

module.exports = {
  project: package.name,
  devPort: 7200,
  devStaticPort: 7201,
  tracingOrigins: [
    'https://version-hiya-web.mehiya.com/', // 根据H5 host来修改
    'http://me-hiya-web-version-test.ixiaochuan.cn/', // 根据H5 host来修改
  ],
  ...hiayConfig,
}
